import { FOCUSABLE_ERROR_INPUT_CLASS } from '@front-app/components/form/form';
import { isVue } from '@front-app/util/types';
import { Ref, nextTick } from '@vue/composition-api';
import { FocusableElement } from './useAsyncModal';

const INVALID_SELECTOR = `:invalid, .${FOCUSABLE_ERROR_INPUT_CLASS}`;

export interface FocusConfig {
	containerSelector?: string;
	containerRef?: Ref<Vue | Element | null>;
	scrollConfig?: ScrollIntoViewOptions;
}

export interface UseFocusFirstInvalidField {
	focusFirstInvalid(): void;
}

const DEFAULT_SCROLL_CONFIG: ScrollIntoViewOptions = {
	block: 'center',
};

export const useFocusFirstInvalidField = (conf: FocusConfig = {}): UseFocusFirstInvalidField => {
	const focusFirstInvalid = async () => {
		await nextTick();
		const container = getContainer(conf);
		const el: FocusableElement | null = container.querySelector(INVALID_SELECTOR);
		el?.focus();
		el?.scrollIntoView(conf.scrollConfig || DEFAULT_SCROLL_CONFIG);
	};
	return {
		focusFirstInvalid,
	};
};

function getContainer(conf: FocusConfig): Element | Document {
	if (conf.containerSelector) {
		return document.querySelector(conf.containerSelector) || document;
	}
	const refVal = conf.containerRef?.value;
	if (refVal) {
		if (isVue(refVal)) {
			return refVal.$el;
		}
		return refVal;
	}
	return document;
}
